import React from 'react';
import DialogWrapper from '../../../../../custom-widgets/dialogs/DialogWrapper';
import { Button, Card, CardActionArea, Grid, Icon, makeStyles, Typography } from '@material-ui/core';
import { DialogActions } from '@mui/material';

const useStyles = makeStyles(() => ({
    button: {
        height: '60px',
        width: '100%',
        justifyContent: 'start',
    },
    cardActions: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'start',
        padding: '16px',
    },
    cardIconGrid: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    cardIcon: {
        fontSize: '30px',
    },
}));

const AddPaymentLineItemRateDialog = ({ dialogOpen, handleClose, addNewRate, addExistingRate }) => {
    const classes = useStyles();
    const handleAddNewRate = () => {
        addNewRate();
        handleClose();
    };
    const handleAddExistingRate = () => {
        addExistingRate();
        handleClose();
    };
    return (
        <DialogWrapper
            Title="Add Rate"
            open={dialogOpen}
            handleClose={handleClose}
            draggable
            actions={<CloseAction handleClose={handleClose} />}
            // wrap
        >
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <DialogCard
                        classes={classes}
                        title="Create New Rate"
                        description="Create a new rate specific to this rule"
                        icon="add_circle_outline"
                        onClick={handleAddNewRate}
                        // wrap
                    />
                </Grid>
                <Grid item xs={12}>
                    <DialogCard
                        classes={classes}
                        title="Use Existing Rate"
                        description="Select from previously created MooRule rates"
                        icon="format_list_bulleted"
                        onClick={handleAddExistingRate}
                        // wrap
                    />
                </Grid>
            </Grid>
        </DialogWrapper>
    );
};

const DialogCard = ({ title, description, icon, onClick, classes }) => {
    return (
        <Card variant="outlined">
            <CardActionArea className={classes.cardActions} onClick={onClick}>
                <Grid container spacing={2}>
                    <Grid item xs={1} className={classes.cardIconGrid}>
                        <Icon color="primary" className={classes.cardIcon}>
                            {icon}
                        </Icon>
                    </Grid>
                    <Grid item xs={11}>
                        <Typography variant="body1">{title}</Typography>
                        <Typography color="textSecondary">{description}</Typography>
                    </Grid>
                </Grid>
            </CardActionArea>
        </Card>
    );
};

const CloseAction = ({ handleClose }) => {
    return (
        <DialogActions>
            <Button variant="outlined" color="primary" onClick={handleClose}>
                Cancel
            </Button>
        </DialogActions>
    );
};

export default AddPaymentLineItemRateDialog;
